var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayer4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 55,
    viewBox: "0 0 119 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4851 34.5018C20.6222 30.8911 38.2605 28.0957 59.7121 28.0957C81.1637 28.0957 98.8121 30.8911 100.944 34.4967C100.841 35.0599 100.692 35.6138 100.498 36.1527C97.0295 46.5341 80.0901 54.4088 59.707 54.4088C39.3239 54.4088 22.3946 46.5341 18.9257 36.178C18.7354 35.6316 18.5881 35.0712 18.4851 34.5018Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7171 48.5903C91.9059 48.5903 118 40.1855 118 29.8176C118 19.4497 91.9059 11.0449 59.7171 11.0449C27.5283 11.0449 1.4342 19.4497 1.4342 29.8176C1.4342 40.1855 27.5283 48.5903 59.7171 48.5903Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7171 45.9858C91.9059 45.9858 118 37.581 118 27.2131C118 16.8452 91.9059 8.44043 59.7171 8.44043C27.5283 8.44043 1.4342 16.8452 1.4342 27.2131C1.4342 37.581 27.5283 45.9858 59.7171 45.9858Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8067 20.9145C80.6876 24.5505 71.2126 27.3358 59.7221 27.3358C48.2316 27.3358 38.7769 24.5505 37.6426 20.9196C37.6983 20.3575 37.7793 19.8055 37.8806 19.2636C38.8038 14.141 41.4975 9.50553 45.4912 6.16723C49.4849 2.82892 54.5245 1 59.7297 1C64.9349 1 69.9746 2.82892 73.9683 6.16723C77.9619 9.50553 80.6557 14.141 81.5788 19.2636C81.67 19.8004 81.751 20.3524 81.8067 20.9145Z",
    fill: "#70FF00",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9232 20.1849C81.9225 20.4325 81.8832 20.6785 81.8068 20.9141C80.6876 24.5501 71.2126 27.3354 59.7221 27.3354C48.2317 27.3354 38.777 24.5501 37.6426 20.9191C37.5662 20.6836 37.5269 20.4376 37.5261 20.1899C37.5271 19.8065 37.6172 19.4285 37.7895 19.0859L37.8806 19.2632C39.7493 22.5954 48.8242 25.1274 59.7323 25.1274C70.6404 25.1274 79.7102 22.5954 81.5789 19.2632L81.67 19.0859C81.838 19.4278 81.9246 19.8039 81.9232 20.1849Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.10535 31.6855C3.10535 31.6855 18.5863 22.1093 37.6426 21.5117",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.445 31.6855C116.445 31.6855 100.944 22.1093 81.9232 21.5117",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0931 26.8086C73.6335 31.5727 77.6784 37.837 79.7406 44.847",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2371 26.8086C44.6973 31.5733 40.6526 37.8373 38.5896 44.847",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7171 40.0818C62.0356 40.0818 63.9152 38.2023 63.9152 35.8837C63.9152 33.5651 62.0356 31.6855 59.7171 31.6855C57.3985 31.6855 55.5189 33.5651 55.5189 35.8837C55.5189 38.2023 57.3985 40.0818 59.7171 40.0818Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.862 19.6507C105.133 18.525 103.367 17.1338 100.917 16.5434C98.4674 15.953 96.2615 16.3869 95.9902 17.5126C95.7189 18.6383 97.485 20.0294 99.9348 20.6198C102.385 21.2102 104.59 20.7763 104.862 19.6507Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9754 20.6197C21.4252 20.0292 23.1913 18.6381 22.92 17.5124C22.6487 16.3868 20.4428 15.9529 17.993 16.5433C15.5432 17.1337 13.7772 18.5248 14.0485 19.6505C14.3197 20.7762 16.5256 21.2101 18.9754 20.6197Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9762 34.4882C95.0421 33.0247 94.0349 30.4752 91.7264 28.7937C89.4179 27.1122 86.6824 26.9355 85.6164 28.399C84.5504 29.8625 85.5577 32.4119 87.8661 34.0934C90.1746 35.7749 92.9102 35.9516 93.9762 34.4882Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.0021,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9299 34.0454C34.237 32.3723 35.2474 29.8302 34.1867 28.3676C33.126 26.905 30.3958 27.0756 28.0887 28.7488C25.7816 30.422 24.7711 32.964 25.8318 34.4266C26.8925 35.8893 29.6227 35.7186 31.9299 34.0454Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7534 16.1129C80.7534 16.1129 83.5437 11.2666 89.3624 11.0488",
    stroke: "black",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.61 16.1129C38.61 16.1129 35.8196 11.2666 30.001 11.0488",
    stroke: "black",
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer4);
export default __webpack_public_path__ + "static/media/Layer 4.00c68c25ee4693fefd5e481a4d4bb61a.svg";
export { ForwardRef as ReactComponent };